<template>
    <div id="app-layout">
        <nav-bar></nav-bar>

        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>

        <waiting-spinner></waiting-spinner>
        <waiting-progress></waiting-progress>
    </div>
</template>

<script>
    import NavBar from './commons/nav/NavBar'
    import WaitingSpinner from './commons/spinner/WaitingSpinner'
    import WaitingProgress from 'nprogress'
    import 'nprogress/nprogress.css'
    WaitingProgress.configure({showSpinner: false})
    
    import {EventBus} from 'js/event-bus'

    export default {
        name: 'Layout',
        components: {
            NavBar,
            WaitingProgress,
            WaitingSpinner
        },
        created () {
           // localStorage.getItem("userMsg") && this.$store.replaceState(Object.assign(this.$store.state,JSON.parse(localStorage.getItem("userMsg"))));
           // 
           // window.addEventListener("beforeunload",()=>{
           //     localStorage.setItem("userMsg",JSON.stringify(this.$store.state))
           // })

            this.getUser()
        },
        mounted () {
            EventBus.$on('startProgress', () => {
                WaitingProgress.start()
            })

            EventBus.$on('doneProgress', () => {
                WaitingProgress.done()
            })
        },
        methods: {
            getUser () {
                this.$store.dispatch('getUser')
            }
        }
    }
</script>

<style>
</style>
